import { render, staticRenderFns } from "./CheckboxInput.vue?vue&type=template&id=6035704a&scoped=true"
import script from "./CheckboxInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./CheckboxInput.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CheckboxInput.vue?vue&type=style&index=0&id=6035704a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6035704a",
  null
  
)

export default component.exports